import { GeometryService } from "../ui-services/geometry-ui-service";
import container from "../../ioc/inversify.config";
import TYPES from "../../ioc/types";
import getDecorators from "inversify-inject-decorators";
import { Events } from "../../shared/enum";

const { lazyInject } = getDecorators(container);

export class BoxOptions {
    fillColor: number;
    fillAlpha: number;
    lineWidth: number;
    lineColor: number;
    lineAlpha: number;
    frameAlpha: number;
    frameColor: number;
}

export class Message extends Phaser.GameObjects.Container {
    private text: Phaser.GameObjects.Text;
    private hideEvent: Phaser.Time.TimerEvent;
    private battleEvents: Phaser.Events.EventEmitter;

    @lazyInject(TYPES.GeometryService)
    private geometryService: GeometryService;

    constructor(scene: Phaser.Scene, events: Phaser.Events.EventEmitter) {
        const x = scene.physics.world.bounds.centerX;
        const y = 30;
        super(scene, x, y);

        this.battleEvents = events;

        const graphics = this.scene.add.graphics();

        this.add(graphics);
        this.geometryService.initGraphicContext(graphics);
        this.geometryService.drawBox(-90, -15, 180, 30, {
            lineAlpha: 0.8,
            fillAlpha: 0.3,
        } as BoxOptions);

        this.text = new Phaser.GameObjects.Text(scene, 0, 0, "", {
            color: "#ffffff",
            align: "center",
            fontSize: "13",
            wordWrap: { width: 170, useAdvancedWrap: true },
        });
        this.add(this.text);
        this.text.setOrigin(0.5);
        events.on(Events.MESSAGE, this.showMessage, this);
        this.visible = false;
    }

    preDestroy() {
        if (this.hideEvent) {
            this.hideEvent.remove(false);
        }
        this.battleEvents.off(Events.MESSAGE, this.showMessage, this);
    }

    public showMessage(text: string) {
        this.text.setText(text);
        this.visible = true;
        if (this.hideEvent) this.hideEvent.remove(false);
        this.hideEvent = this.scene.time.addEvent({
            delay: 2000,
            callback: this.hideMessage,
            callbackScope: this,
        });
    }

    public hideMessage() {
        this.hideEvent = null;
        this.visible = false;
    }
}
